import React, { useState, useEffect } from "react";
import { fetchData } from "../../api/utils"; // Assuming this function is for API calls.
import { useParams, Link, useLocation } from "react-router-dom";
import ProgressBar from "../Shared/ProgressBar";
import assessmentInterpretations from "../../utils/ScoreInterpretation";
import { decodeData, fetchOutcomesByAsssessmentAndUserId } from "../../api/AssessmentHelper";
import { getUserId, getAccesstoken } from "../../utils/auth";

// Updated assessmentInterpretations with out_of_score parameter and specific condition

const getScoreInterpretation = (assessmentName, score, additionalParams = {}) => {

  const assessment = assessmentInterpretations[assessmentName];
  if (!assessment) {
    return { interpretation: "No interpretation available for this assessment.", out_of_score: 0 };
  }

  let adjustedScore = score;
  let interpretation = "";
  const { out_of_score, interpretations, specificConditions } = assessment;

  // Check specific conditions and adjust the score if criteria match
  if (specificConditions) {
    specificConditions.forEach(({ condition, interpretation: conditionInterpretation }) => {
      if (condition(additionalParams)) {
        adjustedScore += 1; // Increase the score for each matching condition
        interpretation += `${conditionInterpretation} `;
      }
    });
  }

  // Find interpretation based on the adjusted score
  if (!interpretation) {
    for (let { range, interpretation: rangeInterpretation } of interpretations) {
      if (adjustedScore >= range[0] && adjustedScore <= range[1]) {
        interpretation = rangeInterpretation;
        break;
      }
    }
  }

  if (!interpretation) {
    interpretation = "No interpretation found for this score.";
  }

  return { interpretation, out_of_score, adjustedScore };
};

const ViewResults = () => {
  // const { assessmentId } = useParams(); // Get assessmentId from the URL
  const [response, setResponse] = useState(null); // Store single response object
  const [loading, setLoading] = useState(false);
  const [assessmentDetails, setAssessmentDetails] = useState(null); // Store assessment details
  const [error, setError] = useState(null);
  const access_token = getAccesstoken();
  const user_id = getUserId(); // Hardcoded user_id for now
  const params = useParams();
  const location = useLocation();

  const assessmentId = params.assessmentId;
  // Extract query parameters
  const searchParams = new URLSearchParams(location.search);


  const encodedData = searchParams.get("details");

 
  
  const { name: assessmentName } = decodeData(encodedData);

  useEffect(() => {
    const fetchResponse = async () => {
      setLoading(true);
      setError(null);
      try {
        
        const data = await fetchOutcomesByAsssessmentAndUserId(assessmentId, user_id, access_token);
          
        setResponse(data || null);
      } catch (error) {
        setError("Failed to load data.");
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchResponse();
  }, [assessmentId, access_token]);

  if (loading) {
    return <p>Loading response...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  if (!response) {
    return <p>No response found for this assessment.</p>;
  }

  // const assessmentName = assessmentDetails?.name || "Assessment";
  const additionalParams = {
    waistCircumference: response.waistCircumference,
    wthRatio: response.wthRatio,
    bri: response.bri,
    gender: response.gender,
  };

  const { interpretation, out_of_score, adjustedScore } = getScoreInterpretation(
    assessmentName,
    response.total_score,
    additionalParams
  );

  return (
    <div>
      <div className="row mb-3">
        <div className="col-xl-12 mb-3">
          <div className="assesment-cards">
            <div className="dashboard-title mb-3">
              <div className="font-md fw-semibold">Results for {assessmentName} Assessment</div>
            </div>
            <h3>Your Score: {adjustedScore} {out_of_score ? ` / ${out_of_score}` : ''}</h3><br />
            {/* <h3>Status: {response.status}</h3><br /> */}
            <h3>Result: <span style={{ fontSize: '16px', marginTop: '10px', lineHeight: '20px', fontWeight: 'normal' }}>{interpretation}</span></h3><br></br>
            {assessmentInterpretations[assessmentName]?.progressBarSettings && (
              <ProgressBar
                score={adjustedScore}
                thresholds={assessmentInterpretations[assessmentName].progressBarSettings.thresholds}
                labels={assessmentInterpretations[assessmentName].progressBarSettings.labels}
                colors={assessmentInterpretations[assessmentName].progressBarSettings.colors}
              />
            )}
          </div>
          <br />
          <Link style={{ fontSize: "22px", paddingTop: '25px', marginTop: '20px' }} to={"/user/assessments"}><i className="fa-solid fa-left-long icon"></i> Back </Link>
        </div>
      </div>
    </div>
  );
};

export default ViewResults;
